export default __webpack_public_path__ + "static/customer-exp.url-715da96296746d6cac7f4501f6b169a6.svg";